module.exports = __webpack_public_path__ + "img/arow_up.906f20eb.svg";